export const iconFontAwesomeArrowsArrowsUpToLine = (
	<i className="fa-solid fa-arrows-up-to-line"></i>
);
